import { ChartDataSeriesGroupEntity } from '../types'

export const checkHasGroup = (entity: ChartDataSeriesGroupEntity) => {
  return entity.ids.length > 0 && entity.ids[0] !== ''
}
